/**
 * Flattens a nested array of objects based on a specified key.
 *
 * This function traverses through each object in the array, recursively flattening any nested arrays found under the specified key. The nested objects are merged into a single-level array.
 *
 * @param {Object[]} arr - The array of objects to be flattened.
 * @param {String} [key='items'] - The key that contains the nested array of objects.
 * @return {Object[]} The flattened array of objects.
 */
const flattenObjectsByKey = ( arr, key = 'items' ) => {
	const result = [];

	/**
	 * Recursively flattens the object.
	 *
	 * @param {Object} item - The object to flatten.
	 */
	const flatten = ( item ) => {
		result.push( item );

		if ( item[key] && Array.isArray( item[key] ) ) {
			item[key].forEach( subItem => flatten( subItem ) );
			delete item[key];  // Optionally remove the nested items to prevent duplicates
		}
	};

	arr.forEach( item => flatten( item ) );

	return result;
};

export default flattenObjectsByKey;
